import i18next from "i18next";

export const formatMonth = (date = new Date()) =>
  date.toLocaleDateString(i18next.language, { month: "short" });

export const getNextMonth = (monthsToAdd) => {
  const date = new Date();
  date.setMonth(date.getMonth() + monthsToAdd);
  return formatMonth(date);
};

export const formatDate = (date = new Date()) =>
  date.toLocaleDateString(i18next.language, { day: "2-digit", month: "short" });

export const isSameDay = (date1, date2 = new Date()) =>
  formatDate(date1) === formatDate(date2);

export const getMonthYear = (monthsToAdd) => {
  const date = new Date();
  date.setMonth(date.getMonth() + monthsToAdd);
  return {
    month: formatMonth(date),
    year: date.getFullYear().toString(),
  };
};

export const getNextMonths = (count) => {
  const months = [];
  for (let i = 0; i < count; i++) {
    const date = new Date("Wed Dec 13 2024");
    date.setMonth(date.getMonth() + i);
    months.push(date.toLocaleDateString(i18next.language, { month: "short" }));
  }
  return months;
};

export const formatDateToDayMonth = (date = new Date()) =>
  date.toLocaleDateString(i18next.language, { day: "2-digit", month: "short" });

export const formatTimeToHourMinute = (date = new Date()) =>
  date.toLocaleTimeString(i18next.language, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

export const getMonthYearInFuture = (monthsToAdd) => {
  const date = new Date();
  date.setMonth(date.getMonth() + monthsToAdd);

  const month = date.toLocaleDateString(i18next.language, { month: "short" });
  const year = date.getFullYear().toString();

  return { month, year };
};
